import { Box, styled, Typography } from "@mui/material";

const GreyChip = styled(Typography)(({ theme }) =>
  theme.unstable_sx({
    padding: theme.spacing(0, 1),
    ...theme.typography.button,
    fontSize: "12px",
    zIndex: 1,
    backgroundColor: "white",
    borderRadius: "100px",
    whiteSpace: "nowrap",
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    gap: 0.5,
    ".MuiSvgIcon-root": {
      fontSize: "12px",
    },
  })
);

export default function AspectSelectedLabel({
  label,
  selectedLabel,
  children
}: {
  label: React.ReactNode;
  selectedLabel?: string;
  children: React.ReactNode;
}) {
  return (
    <Box
      sx={{
        display: "flex",
        position: "relative",
        gap: 2,
        alignItems: "center",
      }}
    >
      {!!selectedLabel && (
        <GreyChip
          sx={(theme) => ({
            position: "absolute",
            top: theme.spacing(-1.5),
            left: "50%",
            transform: "translateX(-50%)",
          })}
        >
          {label}
        </GreyChip>
      )}
      {children}
    </Box>
  );
}
